<template>
<div>
  <el-form  :model="formInline" class="demo-form-inline">
    <el-form-item label="公众号">
      <el-select v-model="formInline.wxId"  placeholder="请选择公众号" @change="wechatChange">
        <el-option
            v-for="item in wechatNameSelect"
            :key="item.appId"
            :label="item.appName"
            :value="item.appId">
        </el-option>
      </el-select>
    </el-form-item>

    <el-row>
      <el-col :span="12">
        <el-form-item label="旧标签">
          <el-select v-model="formInline.oldLabel"  multiple collapse-tags placeholder="请选择旧标签" @change="oldLabel">
            <el-option
                v-for="item in oldLabelSelect"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="新标签">
          <el-select v-model="formInline.newLabel" multiple collapse-tags placeholder="请选择新标签" @change="newLabel">
            <el-option
                v-for="item in newLabelSelect"
                :key="item.id"
                :label="item.text"
                :value="item.id"
                :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-form-item label="关注时间">
          <el-date-picker
              v-model="formInline.date" type="daterange" align="center" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              @change="we">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>


  </el-form>

  <div align="center">
    <el-button type="success" @click="submit">保存</el-button>
    <el-button type="danger" @click="close">关闭</el-button>
  </div>

</div>
</template>

<script>
import {setLabel} from "@/request/http";

export default {
  data() {
    return {
      formInline: {
        wxId:'0',
        oldLabel:'',
        newLabel:'',
        date:'',
        startDate:'',
        endDate:'',
      },
      wechatNameSelect:[],
      oldLabelSelect:[],
      newLabelSelect:[],
      info:[],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.getWx()
    this.wechatChange('0')
    // 初始化默认时间
    this.defaultDate()
  },
  methods: {
    // 初始化默认时间
    defaultDate() {
      var date = new Date()
      var year = date.getFullYear().toString()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
      // var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
      var da = new Date(date.getFullYear(), month, 0).getDate()
      da < 10 ? '0' + da.toString() : da.toString()
      var beg = year + '-' + month + '-01'
      var end = year + '-' + month + '-' + da
      this.formInline.date = [beg, end] //将值设置给插件绑定的数据
      this.formInline.startDate=beg
      this.formInline.endDate=end
    },
    we(){
      if(this.formInline.date!=null){
        this.formInline.startDate=this.formInline.date[0]
        this.formInline.endDate=this.formInline.date[1]
      }
    },
    getWx(){
      this.$http.get_wxconfig(null).then(res=>{
        this.wechatNameSelect = res.data
        this.wechatNameSelect.unshift( {appName:"全部",appId:"0"})
      })
    },
    wechatChange(e){
        this.$http.LabelStatistics({wxId:e}).then(res => {
          this.oldLabelSelect = res.data.map((item)=>{
            return {
              ...item, // 复制原始对象的属性
              label: item.text + "(" + item.total + ")" // 添加新属性label
            };
          })
        })
    },
    oldLabel(e){
      this.formInline.newLabel=[]
      this.newLabelSelect=[]
      if(e.length==0){
        this.oldLabelSelect.map((item) => {
           item.disabled=false
        })
      }else {

        //
        // 判断集合中是否包含 "全部",并且只选择了一条
        const hasBanana = e.includes("0");
        if(hasBanana &&  e.length==1){
          this.newLabelSelect=JSON.parse(JSON.stringify(this.oldLabelSelect))
          this.newLabelSelect.shift();
          this.oldLabelSelect.map((item)=>{
            if(item.id!="0"){
              item.disabled=true
            }
          })
        }

        if(!hasBanana &&  e.length>=1){
          this.oldLabelSelect.map((item)=>{
            if(item.id=="0"){
              item.disabled=true
            }
          })
          this.removeItems(e)
        }

      }


    },
    newLabel(e){
      if(e.length==0){
        this.newLabelSelect.map((item) => {
          item.disabled=false
        })
      }else {

        // 判断集合中是否包含 "全部",并且只选择了一条
        const hasBanana = e.includes("0");
        if(hasBanana &&  e.length==1){
          this.newLabelSelect.map((item)=>{
            if(item.id!="0"){
              item.disabled=true
            }
          })
        }

        if(!hasBanana &&  e.length>=1){
          this.newLabelSelect.map((item)=>{
            if(item.id=="0"){
              item.disabled=true
            }
          })
        }

      }

    },
    removeItems(e){

      this.info= JSON.parse(JSON.stringify(this.oldLabelSelect))
      this.info.map((item) => {
          e.map((items) => {
          if(items==item.id){
            item.disabled=true
          }

        })
      })

      this.newLabelSelect=[]
            this.info.map((item) => {
              if(!item.disabled || item.id=="0"){
                  item.disabled=false
                  this.newLabelSelect.push(item);
              }

          })

    },
    submit(){
        this.$confirm('此操作将修改或者删除客户标签, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$http.setLabel(this.formInline).then(res => {
            // this.formInline.startDate = new Date(this.formInline.startDate).toISOString();
            // this.formInline.endDate = new Date(this.formInline.endDate).toISOString();
            if(res.status == "success"){
              this.$message({type: 'success', message: res.msg, center: true});
              this.getWx()
              this.wechatChange(this.formInline.wxId)
              this.formInline.oldLabel=[]
              this.formInline.newLabel=[]

            }else {
              this.$message({type: 'error', message: res.msg, center: true});
            }

          })
        }).catch(() => {
          this.$message({type: 'info', message: '已取消!', center: true});
        });
    },
      close(){
        this.$emit('close');
      },

  }
}
</script>

<style scoped>

</style>